module.exports = [{
      plugin: require('/Users/dclure/Projects/lab-work-umap/client/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-72367808-1"},
    },{
      plugin: require('/Users/dclure/Projects/lab-work-umap/client/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
